import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { getTicketsCount } from "../../Service/AllTicketServiceAPI";
import NonSlaOpenTicketList from "./NonSlaTicketComp/NonSlaOpenTicketList";
import SlaOpenTicketList from "./SlaTicketComp/SlaOpenTicketList";
import OmcApproved from "./TicketServiceDashboardComp/OmcApproved"
import { getDashboardTotalCount } from "../../Service/DashboardTotalCount"

const TicketServiceTech = () => {
  const [ticketData, setTicketData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeBox, setActiveBox] = useState("");
  const [woCounts, setWoCounts] = useState(null);
  const tableSectionRef = useRef(null);

  const handleBack = () => {
    setActiveBox("");
    fetchTicketData();
    fetchDashboardTotalCount();
  };

  const fetchTicketData = async () => {
    try {
      const response = await getTicketsCount();
      setTicketData(response.data);
    } catch (error) {
      console.error("Error fetching ticket data:", error);
      setTicketData(null);
    } finally {
      setLoading(false);
    }
  };


  const fetchDashboardTotalCount = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const role = sessionStorage.getItem("role");
    const fkUserId = sessionStorage.getItem("pkUserId");

    if (!token || !role || !fkUserId) {
      console.error("Missing token, role, or fkUserId in sessionStorage");
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };

    const response = await getDashboardTotalCount(fkUserId, role, headers);

    setWoCounts(response.data || null);
  } catch (error) {
    console.error("Error fetching Field Engineer WO counts:", error);
  }
};

  useEffect(() => {
    fetchTicketData();
    fetchDashboardTotalCount()
  }, []);

  useEffect(() => {
    if (activeBox && tableSectionRef.current) {
      tableSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [activeBox]);

  const toggleBox = (key) => {
    setActiveBox((prev) => (prev === key ? "" : key));
  };

  const renderCard = (count = 0, label, key) => (
    <Col xs={6} md={3} className="d-flex flex-column align-items-center mb-4" onClick={() => toggleBox(key)}>
      <Card
        style={{
          border: "2px solid #0d6efd",
          borderRadius: "12px",
          width: "70%",
          height: "70px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: activeBox === key ? "#cce5ff" : "#fff",
          cursor: "pointer",
        }}
      >
        <Card.Body className="p-2 d-flex align-items-center justify-content-center">
          <h4 className="mb-0">{count ?? 0}</h4>
        </Card.Body>
      </Card>
      <div style={{ marginTop: "5px", fontSize: "16px", textAlign: "center", fontWeight: "bold" }}>
        {label}
      </div>
    </Col>
  );

  const tableTitleMap = {
    nonSlaOpen: "Open Non SLA Tickets",
    slaOpen: "Open SLA Tickets",
    omcApproved: "Approved OMC Tickets",
  };

  // if (loading) {
  //   return (
  //     <div className="text-center mt-5">
  //       <Spinner animation="border" variant="primary" />
  //       <p>Loading ticket data...</p>
  //     </div>
  //   );
  // }

  // if (!ticketData || Object.keys(ticketData).length === 0) {
  //   return (
  //     <div className="text-center mt-5">
  //       <p>No tickets available....</p>
  //     </div>
  //   );
  // }

  return (
    <Container fluid className="p-4" style={{ backgroundColor: "#e8e8e8", minHeight: "100vh" }}>
      <Row className="mb-4 justify-content-center">
        <Col xs="auto" className="text-center">
          <h3
            style={{
              background: "#488AC7",
              color: "#fff",
              padding: "3px 5px",
              borderRadius: "8px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
            }}
          >
            Tech Ticket Service
          </h3>
        </Col>
      </Row>

      {/* SLA Section */}
      <Row className="justify-content-center">
        {renderCard(ticketData?.nonSlaOpen ?? 0, "Open Non SLA Tickets", "nonSlaOpen")}
        {renderCard(ticketData?.omcApproved ?? 0, "Approved OMC Tickets", "omcApproved")}
        {renderCard(ticketData?.slaOpen ?? 0, "Open SLA Tickets", "slaOpen")}
      </Row>

      <div ref={tableSectionRef} className="mt-4">
        {activeBox ? (
          <div className="mb-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3">
              <div>
                <h5 className="mb-1">{tableTitleMap[activeBox] || "Ticket Details"}</h5>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-outline-primary d-flex align-items-center"
                  onClick={handleBack}
                >
                  <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back
                </button>
              </div>
            </div>
            <div style={{ border: "1px solid #cbd5e1", borderRadius: "12px", backgroundColor: "#ffffff", padding: "1rem" }}>
              {activeBox === "nonSlaOpen" && <NonSlaOpenTicketList />}
              {activeBox === "slaOpen" && <SlaOpenTicketList />}
              {activeBox === "omcApproved" && <OmcApproved />}
            </div>
          </div>
        ) : null}
      </div>

      {!activeBox ? (
        <>
          <Row className="mt-4 mb-5 justify-content-center">
            <Col xs="auto">
              <div
                style={{
                  background: "#dcdcdc",
                  padding: "6px 15px",
                  border: "1px solid #ccc",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                All Field Engineer WO Status
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            {renderCard(woCounts?.openWorkOrder ?? 0, "Total Open WO", "openWO")}
            {renderCard(woCounts?.closeWorkOrder ?? 0, "Total Close WO", "closeWO")}
          </Row>
        </>
      ) : null}
    </Container>
  );
};

export default TicketServiceTech;


